export default __webpack_public_path__ + "static/media/_aardappel.e4ce2099.png";